import { PhotoPrintsJson } from './PhotoPrintsJson';

export type VariantAttributes = {
    readonly paperId?: string;
    readonly sizeId?: string;
    readonly borderId?: string;
};

export const isPremiumSupport = (variant: PhotoPrintsJson.Variant): boolean =>
    !!variant.premiumSku;

export const skuFor = (
    variant: PhotoPrintsJson.Variant,
    quality: PhotoPrintsJson.PrintQuality
): string =>
    quality === 'premium' && variant.premiumSku ? variant.premiumSku : variant.sku;

export const findVariant = (
    variants: PhotoPrintsJson.Variant[],
    attributes: VariantAttributes
): PhotoPrintsJson.Variant | undefined =>
    variants.find(v =>
        v.paperId === attributes.paperId
        && v.sizeId === attributes.sizeId
        && v.borderId === attributes.borderId);

export const findVariantBySku = (
    variants: PhotoPrintsJson.Variant[],
    sku: string
): PhotoPrintsJson.Variant | undefined =>
    variants.find(v => v.sku === sku || v.premiumSku === sku);

export const isPremiumSku = (
    variants: PhotoPrintsJson.Variant[],
    sku: string
): boolean =>
    variants.some(v => v.premiumSku === sku);